import { render, staticRenderFns } from "./riskClass.vue?vue&type=template&id=61045963&"
import script from "./riskClass.vue?vue&type=script&lang=js&"
export * from "./riskClass.vue?vue&type=script&lang=js&"
import style0 from "./riskClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports